import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GiphyService {
  private http = inject(HttpClient);
  private apiKey = 'ewDtDUXZuC5eBuxxDWur5ayAZKmcnq7b';
  private url = `https://api.giphy.com/v1/gifs/search?api_key=${this.apiKey}`;

  public searchResults = signal<any[]>([]);

  /**
   * Search for GIPHY images
   * @param query Search query
   */
  public search(query: string) {
    const url = `${this.url}&q=${query}&limit=24&offset=0&lang=en`;
    this.http.get(url).subscribe({
      next: (res: any) => {
        this.searchResults.set(res.data);
      },
      error: (err: any) => {
        console.error(err);
      }
    });
  }
}
